<template>
  <div class="continuous-auctions-bids-list page page-with-table p-2">
    <page-header class="mb-2" :title="$t('Bids')"/>
    <div class="card content-wrapper p-2">
      <BidsTable v-if="loadTable"/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import BidsTable from "@/modules/bids/BidsTable";
  import PageHeader from "../../core/components/page-header/PageHeader";

  const {mapActions} = createNamespacedHelpers('bids');
  const {mapState} = createNamespacedHelpers('global');

  export default {
    name: "BidsList",
    components: {PageHeader, BidsTable},
    data() {
      return {
        loadTable: true,
      }
    },
    computed: {
      ...mapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
    },
    methods: {
      ...mapActions(['updateTableSource'])
    },
    async beforeMount() {
      if (this.enableContinuousAuction) {
        await this.updateTableSource({
          source: 'bids',
          extraFilters: {
            auction_uuid: null
          },
          sale: {},
          extraExpands: 'bidder.auction.currency',
        });
      } else if (this.$route.path === '/bids') {
        this.loadTable = false;
        await this.$router.push({name: 'not-found'});
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "./scss/variables";

  .continuous-auctions-bids-list {
    @include list-view-wrapper;
  }
</style>
